import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import App from './App.tsx';
import { applyTheme } from './store/ui.store.ts';
import './index.css';

// Initialize theme on load
const savedUI = localStorage.getItem('crm-ui');
if (savedUI) {
  try {
    const { state } = JSON.parse(savedUI);
    applyTheme(state?.theme ?? 'system');
  } catch {
    applyTheme('system');
  }
} else {
  applyTheme('system');
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            borderRadius: '8px',
            fontSize: '14px',
          },
        }}
      />
    </QueryClientProvider>
  </React.StrictMode>,
);
